import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { fDateTimeWithTimezone } from "../../../../../utils/formatTime";

OrderLogRerun.propTypes = {
  logItem: PropTypes.object,
}

export default function OrderLogRerun({ logItem }) {
  return <Box>
    <Typography variant="body" color="info.main" sx={{wordBreak: 'break-word', whiteSpace: 'normal'}}>
      {logItem.vendorName} items rerun {logItem.rerunBy ? `by ${logItem.rerunBy}` : ''}
    </Typography>
    <Typography variant="body2" color="black">
      {fDateTimeWithTimezone(logItem.dateAdded)}
    </Typography>
  </Box>
}